export default function ProjectLogoIcon({ size = 50 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 46 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="46" height="46" rx="7" fill="#FFB64F" />
      <path
        d="M10.2057 42.6667H13.4114V29.3333H32.6457V42.6667H35.8514V24.9167L23.0286 19.5833L10.2057 24.9167V42.6667ZM7 46V22.6667L23.0286 16L39.0571 22.6667V46H29.44V32.6667H16.6171V46H7ZM18.22 46V42.6667H21.4257V46H18.22ZM21.4257 41V37.6667H24.6314V41H21.4257ZM24.6314 46V42.6667H27.8371V46H24.6314Z"
        fill="#E77700"
      />
    </svg>
  );
}

/**
 * Project Dashboard glyph for menus. The 12×14 artwork is centred in a
 * square viewBox so it lines up with the other square module icons.
 */
export function ProjectDashboardCiqIcon({
  size = 14,
  className = "fill-white",
  opacity = "1"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-1 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.48494 11.8666H2.61637V6.53328H9.40494V11.8666H10.5364V4.76662L6.01066 2.63328L1.48494 4.76662V11.8666ZM0.353516 13.2V3.86662L6.01066 1.19995L11.6678 3.86662V13.2H8.27352V7.86662H3.7478V13.2H0.353516ZM4.31352 13.2V11.8666H5.44494V13.2H4.31352ZM5.44494 11.2V9.86662H6.57637V11.2H5.44494ZM6.57637 13.2V11.8666H7.7078V13.2H6.57637Z"
        fill="current"
        fillOpacity={opacity}
      />
    </svg>
  );
}
